module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Vue Monthly Picker")]), _vm._v(" "), _c('div', {
    staticClass: "demo-component"
  }, [_c('vue-monthly-picker', {
    attrs: {
      "inputClass": {
        'input': _vm.isDisplayInput
      },
      "disabled": _vm.isDisable,
      "monthLabels": _vm.locale,
      "clearOption": _vm.clearOption,
      "min": _vm.min,
      "max": _vm.max,
      "alignment": _vm.alignment,
      "selectedBackgroundColor": _vm.selectedBackgroundColor
    },
    on: {
      "selected": _vm.handleSelect
    },
    model: {
      value: (_vm.selectedMonth),
      callback: function($$v) {
        _vm.selectedMonth = $$v
      },
      expression: "selectedMonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns option-list"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('b-field', {
    attrs: {
      "label": "Disabled",
      "expanded": ""
    }
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.isDisable),
      callback: function($$v) {
        _vm.isDisable = $$v
      },
      expression: "isDisable"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isDisable ? 'Disabled' : 'Enable') + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b-field', {
    attrs: {
      "label": "Range",
      "expanded": ""
    }
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.isLimitRange),
      callback: function($$v) {
        _vm.isLimitRange = $$v
      },
      expression: "isLimitRange"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.rangeDisplay) + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b-field', {
    attrs: {
      "label": "Display",
      "expanded": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    attrs: {
      "true-value": "Input",
      "false-value": "Label"
    },
    model: {
      value: (_vm.isDisplayInput),
      callback: function($$v) {
        _vm.isDisplayInput = $$v
      },
      expression: "isDisplayInput"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isDisplayInput ? 'Input' : 'Label') + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b-field', {
    attrs: {
      "label": "Clear icon",
      "expanded": ""
    }
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.clearOption),
      callback: function($$v) {
        _vm.clearOption = $$v
      },
      expression: "clearOption"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.clearOption ? 'Enable' : 'Disabled') + "\n          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('b-field', {
    attrs: {
      "label": "Localization",
      "expanded": ""
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a language"
    },
    model: {
      value: (_vm.locale),
      callback: function($$v) {
        _vm.locale = $$v
      },
      expression: "locale"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.monthLabels
      }
    }, [_vm._v("\n                " + _vm._s(option.title) + "\n            ")])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('b-field', {
    attrs: {
      "label": "Alignment",
      "expanded": ""
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select an alignment"
    },
    model: {
      value: (_vm.alignment),
      callback: function($$v) {
        _vm.alignment = $$v
      },
      expression: "alignment"
    }
  }, _vm._l((_vm.alignments), function(alignment) {
    return _c('option', {
      key: alignment,
      domProps: {
        "value": alignment
      }
    }, [_vm._v("\n               " + _vm._s(alignment) + "\n           ")])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('b-field', {
    attrs: {
      "label": "Selected background color",
      "expanded": ""
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select an color"
    },
    model: {
      value: (_vm.selectedBackgroundColor),
      callback: function($$v) {
        _vm.selectedBackgroundColor = $$v
      },
      expression: "selectedBackgroundColor"
    }
  }, _vm._l((_vm.colorExamples), function(color) {
    return _c('option', {
      key: color,
      domProps: {
        "value": color
      }
    }, [_vm._v("\n                " + _vm._s(color) + "\n            ")])
  }))], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-343eaaea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 20
// module chunks = 0